import { useCustomContext } from './ContextHook';

const RoundedImg = () => {
    const context = useCustomContext()
    return (
        <div className="profile-img-wrapper">
            <div className='story'>
                <div className="profile">
                    <img src={context.user.photo} alt="User" />
                </div>
            </div>
        </div>
    )
}

export default RoundedImg
